import type { BrightnessLandTuning, SquashLandTuning } from "@slot/presentation";

/** The symbols whose sprite land look plays when the symbols run without Spine: the scatter. */
export const SPRITE_LAND_SYMBOL_IDS: readonly string[] = ["FS"];

/**
 * The symbols that never play the Spine land clip (`in`): the five card ranks (user, 2026-09-11) and,
 * TEMPORARILY (user, 2026-10-05), the compass H2, the rum bottle H3 and the scatter FS — drop those three
 * to bring their land clips back. The set also suppresses the drum's PRE-LAND POSE — a symbol posed on the
 * clip's first frame and then never animated would sit frozen on it until the all-stop render — so a
 * skipped symbol arrives resting: the card ranks as their plain sprite, H2 / H3 / FS already on their idle
 * loop. Their land sounds, the drop thud and the grid bounce are unchanged.
 */
export const SPINE_LAND_SKIP_SYMBOL_IDS: readonly string[] = ["L1", "L2", "L3", "L4", "L5", "H2", "H3", "FS"];

/**
 * The FS squash-and-settle pop when a scatter lands, for a build without Spine symbols (the Spine
 * `in` clip is the land look otherwise). Scales are multipliers on the cell's rest scale, durations
 * seconds; nothing waits for the pop (decision 20).
 */
export const SQUASH_LAND_TUNING: SquashLandTuning = {
  squashScaleX: 1.15, // widen 15% at peak
  squashScaleY: 0.85, // flatten 15% at peak
  squashSeconds: 0.08, // quick squash in
  squashEasing: "quadOut",
  settleSeconds: 0.16, // settle back to rest
  settleEasing: "backOut", // slight overshoot pop
  squashOffsetX: 0,
  squashOffsetY: -10, // shift the content DOWN at peak so the squash squeezes to the BOTTOM
};

/** The FS brightness shine when a scatter lands, composed with the squash. */
export const FS_LAND_SHINE_TUNING: BrightnessLandTuning = {
  peak: 2, // apex exposure gain above 1×: 0 = untouched, 1 = 2×, 2 = 3×
  startDelayMilliseconds: 0, // shine right as it lands
  rampUpSeconds: 0.05,
  rampUpEasing: "quadOut",
  holdSeconds: 0.01,
  rampDownSeconds: 0.3,
  rampDownEasing: "quadIn",
};
